import { useAuth } from 'context/AuthProvider'
import { useSelector } from 'react-redux'

import { clearStorage } from 'utils/storage'

import { getUserId } from 'store/currentUser/selectors'

import { LOGOUT } from 'routes/paths'

export const useNavbarLogout = () => {
  const userId = useSelector(getUserId)
  const { logout } = useAuth()

  return (event: React.MouseEvent<HTMLElement>) => {
    clearStorage(`${userId}`)
    event.preventDefault()
    logout(window.location.origin + LOGOUT)
  }
}
